import { render, staticRenderFns } from "./MainWireAddUpdate.vue?vue&type=template&id=14405e40"
import script from "./MainWireAddUpdate.vue?vue&type=script&lang=js"
export * from "./MainWireAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports